import apiFetch from '../apiFetch'

export default function (idAgenda, token) {
  return apiFetch({endPoint: `Agenda/deleteAgendaSerie?idAgenda=` + idAgenda, method: 'GET', body: null, token: token})
}
